import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, useParams, useRouteMatch } from 'react-router-dom';

import { NAV_DRAWER_ITEMS } from '~/features/dashboard';
import { UserProfileMain } from '~/features/dashboard/components/user-profile-main';
import { useHeaderColorChanger } from '~/utils/hooks/useHeaderColorChanger';
import css from './styles.module.scss';
import { selectUserData } from '~/features/dashboard/store/selectors';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import { DownloadButton } from '~/common/download-button';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import { MyDealContacts } from '~/features/dashboard/components/user-contacts/MyDealContacts';

interface MyTeamProps {}

export const MyTeam: React.FC<MyTeamProps> = () => {
    const user = useSelector(selectUserData);
    useHeaderColorChanger(NAV_DRAWER_ITEMS.team.background);

    const match = useRouteMatch();

    const [value, setValue] = React.useState(0);
    // const [contacts, setContacts] = React.useState<User[]>([]);

    function a11yProps(index: any) {
        return {
            id: `tab-${index}`,
            'aria-controls': `tabpanel-${index}`,
        };
    }

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    // const filterContacts = (value: number) => {
    //     let filterContacts: any;
    //     filterContacts = user?.contacts.filter(
    //         (contact: any) =>
    //             contact.contactTypeDesc !== 'My Legal Entity' && contact.contactTypeDesc !== 'My Deal Contact' && contact.contactTypeDesc !== 'Creator'
    //     );
    //     value === 2 && (filterContacts = user?.contacts.filter((contact: any) => contact.contactTypeDesc === 'My Deal Contact'));
    //     return filterContacts;
    // };
    //
    // useEffect(() => {
    //     setContacts(filterContacts(value));
    //     // eslint-disable-next-line
    // }, [user, value]);

    const hasTeam = !value;

    const route = useAppRoute();
    const { creatorId } = useParams();
    const goToPreview = useCallback(() => route(`/creators-list/${creatorId}/dashboard/creator-preview`), [creatorId, route]);

    return (
        <article className={css.module}>
            <div className={css.topBarActions}>
                <AppBar className={css.appTop} position="static">
                    <Tabs value={value} className={css.topBar} onChange={handleChange} aria-label="simple tabs example">
                        <Tab label="My Creator" {...a11yProps(0)} />
                        {/*<Tab label={`My Team (${filterContacts(1).length}) `} {...a11yProps(1)} />*/}
                        <Tab label={`My Team (${user?.dealContacts.length})`} {...a11yProps(2)} />
                    </Tabs>
                </AppBar>
                <DownloadButton className={css.actionSection} onClick={goToPreview} buttonFor="preview" />
            </div>
            <Switch>
                <Route path={match.path} exact>
                    {user && <UserProfileMain user={user} className={!hasTeam ? css.hidden : ''} />}
                    {/*{user && value === 1 && <UserContacts contactsUser={contacts} className={hasTeam ? css.hidden : ''} />}*/}
                    {user && value === 1 && <MyDealContacts companies={user?.dealContacts} className={hasTeam ? css.hidden : ''} />}
                </Route>
            </Switch>
        </article>
    );
};
